// extracted by mini-css-extract-plugin
export default {"inputs":"Search_inputs__VA4xd"};